
<div class="container col-12">

  @if (hasSelection) {
  <div class="row">
    <div class="col-lg">
      <div class="alert alert-info">
        Selected people:
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="emailSelected()">Email</button>
          @if (!profile.profile.employeeData.IsEmployee) {
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="groupSelected(addGroupModal)">Group</button>
          }
        </div>
      </div>
    </div>
  </div>
  }

  @if (byprogram) {
  @for (program of data; track program) {
  <div>
    <div class="col-12 search-subtitle"><strong>{{program.Name}} ({{program.People.length}} results)</strong></div>
    <ng-container [ngTemplateOutlet]="personlist" [ngTemplateOutletContext]="{persons: program.People}"></ng-container>
  </div>
  }
  }
  @if (!byprogram) {
  <ng-container [ngTemplateOutlet]="personlist" [ngTemplateOutletContext]="{persons: data}"></ng-container>
  }

  <ng-template #personlist let-persons="persons">
    <div class="row person-list">
      @for (person of persons; track person.PersonId) {
      <div class="col-sm-6 col-md-6 col-lg-4 col-xl-3 text-center">
        <div class="user-profile card card-fluid" [class.selected]="person.isSelected">
          <div class="profile-card-icons">
            <div class="person-info-buttons">
              <div class="btn-person-email">
                <button class="btn btn-link px-0 py-0" (click)="sendEmail(person.Email)">
                  <i class="fa fa-lg fa-envelope card-action published-data" aria-hidden="true"></i>
                  <span class="sr-only">Click to email this person</span>
                </button>
              </div>
              <div class="btn-person-info">
                <button class="btn btn-link px-0 py-0" (click)="open(person)">
                  @if (!person.IsPublished) {
                  <i class="far fa-lg fa-info-circle card-action non-published-data" aria-hidden="true"></i>
                  }
                  @if (person.IsPublished) {
                  <i class="fa fa-lg fa-info-circle card-action published-data" aria-hidden="true"></i>
                  }
                  <span class="sr-only">Click to view this person's profile</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-header" (click)="person.isSelected = !person.isSelected">
            @if (!!person.Classification && person.Classification == 'FY') {
            <span class="badge badge-light float-end">1Y</span>
            }
            @if (!!person.Classification && person.Classification == 'SY') {
            <span class="badge badge-dark float-end">2Y</span>
            }
          </div>
          <div class="card-body text-center">
            <div class="mb-2">
              <img #profileImg
                   class="user-avatar user-avatar-floated user-avatar-xl align-baseline"
                   src="{{person.photoUrl}}"
                   alt="{{person.PersonFirstLastName}}"
                   (error)="profileImg.src = person.failedPhotoUrl">
              <h3 class="card-title mt-2">
                {{person.PersonFirstLastName}}
              </h3>
            </div>
          </div>
        </div>
      </div>
      }
      @if (persons.length == 0) {
      <span class="bg-contrast-text person-list-none">No one to show. You may need to clear your filter.</span>
      }
    </div>
  </ng-template>

  <ng-template #addGroupModal let-modal>
    <div class="modal-header">
      <h4 tabindex="0" ngbAutofocus class="modal-title" id="modal-basic-title">Create or update a group</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      </button>
    </div>
    <div class="modal-body">
      <p>You've selected {{selectionCount}} {{selectionCount > 1 ? 'people' : 'person'}}. Type the name of a new or existing group to add your selection to that group.</p>
      <form>
        <!-- provide typeahead for existing group names -->
        <div class="form-group">
          <div class="input-group">
            <input id="groupName" name="groupName" ngbAutofocus [(ngModel)]="selectedGroupName" [ngbTypeahead]="groupNames$" class="form-control" placeholder="Type a name for your new or existing group">
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.close('save')">Save</button>
    </div>
  </ng-template>
</div>
